import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import _ from "lodash";
import auth from "@/api/auth";

import eventPaths from "./path.event";
import tournamentPaths from "./path.tournament";
import membershipPaths from "./path.membership";
import golfcoursePaths from "./path.golfcourse";
import supportPaths from "./path.support";
import findlocationPaths from "./path.findlocation";
import hallofFame from "./path.halloffame";
// import userPaths from './path.user'
// import adminPaths from './path.admin'
import i18n from "@/i18n";

Vue.use(VueRouter);

let allowNullName = ["Login", "Logout"];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    /*{
      path: '/',
      name: 'Splash',
      component: () => import(/* webpackChunkName: "login" * / '@/views/Splash'),
      meta: {
        layout: 'NoneLayout'
      }
    },*/
    {
      path: "/",
      name: "main",
      component: () => import(/* webpackChunkName: "main" */ "@/views/Main"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "main",
      },
    },
    {
      path: "/login",
      name: "Login",
      beforeEnter(to, from, next) {
        console.log("to", to);
        console.log("from", from);

        if (
          from.meta &&
          to.meta &&
          to.meta.sub_menu_num !== from.meta.sub_menu_num
        ) {
          // console.log(1111);
          store.commit("setSearchData", {});
        }
        if (sessionStorage.getItem("token")) {
          next({ name: "main" });
        } else {
          next();
        }
      },
      component: () => import(/* webpackChunkName: "login" */ "@/views/Login"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.login.login"),
        m_subtitle: i18n.t("page.login.login"),
        step: [i18n.t("page.login.login")],
      },
    },
    {
      path: "/logout",
      name: "Logout",
      beforeEnter: (to, from, next) => {
        store.dispatch("logout");

        auth.getTimezone((flag) => {});

        next("/");
      },
    },
    {
      path: "/find_id_pwd",
      name: "Find_Id_Pwd",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/Find_Id_Pwd"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.main.id_password_find"),
        m_subtitle: i18n.t("page.main.id_password_find"),
        step: [i18n.t("page.main.id_password_find")],
      },
    },
    {
      path: "/signup",
      name: "SignUp",
      component: () =>
        import(/* webpackChunkName: "signup" */ "@/views/SignUp"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.main.sign_up"),
        m_subtitle: i18n.t("page.main.sign_up"),
        step: [i18n.t("page.main.sign_up")],
      },
    },
    {
      path: "*",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404"),
      meta: {
        layout: "NoneLayout",
      },
    },
    {
      path: "/terms_of_use",
      name: "Terms",
      component: () => import(/* webpackChunkName: "signup" */ "@/views/Terms"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.main.terms_of_use"),
        m_subtitle: i18n.t("page.main.terms_of_use"),
        step: [i18n.t("page.main.terms_of_use")],
      },
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () =>
        import(/* webpackChunkName: "signup" */ "@/views/Privacy"),
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.main.privacy_policy"),
        m_subtitle: i18n.t("page.main.privacy_policy"),
        step: [i18n.t("page.main.privacy_policy")],
      },
    },
  ],
});

router.addRoute(eventPaths);
router.addRoute(tournamentPaths);
router.addRoute(membershipPaths);
router.addRoute(golfcoursePaths);
router.addRoute(supportPaths);
router.addRoute(findlocationPaths);
router.addRoute(hallofFame);

// router.addRoute(userPaths)
// router.addRoute(adminPaths)

router.beforeEach(async (to, from, next) => {
  console.log("to", to);
  console.log("from", from);
  if (
    from.meta &&
    to.meta &&
    from.name &&
    to.meta.sub_menu_num !== from.meta.sub_menu_num
  ) {
    store.commit("setSearchData", {});
  }

  if (!to.matched.length) {
    next("/notFound");
  } else {
    if (store.state.timezone.timezone_name === "") {
      await auth.getTimezone((flag) => {
        if (flag) {
          console.log(111);
          next();
        } else {
          next({
            path: "/dashboard",
            replace: true,
          });
        }
      });
    }
    if (_.includes(allowNullName, to.name)) {
      next();
    } else if (store.state.user && to.name === "Splash") {
      next({
        path: "/dashboard",
        replace: true,
      });
    } else if (!store.state.user && to.name === "Splash") {
      next({
        path: "/dashboard",
        replace: true,
      });
    } else if (store.state.user === null) {
      await auth.refreshToken((flag) => {
        if (flag) {
          next();
        } else {
          next({
            path: "/dashboard",
            replace: true,
          });
        }
      });
    } else {
      next();
    }
  }

  if (from.name) {
    sessionStorage.setItem('previousRoute', from.fullPath);
  }
  next();
});

export default router;
